module.exports = __webpack_public_path__ + "media/flags/mv-fa541791.svg";